<template>
  <div class="chart-item">
    <el-breadcrumb
      separator="/"
      v-if="chartData.type === 'map'"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item v-for="[key, value] in hashMap" :key="key">
        <span @click="initMap(key, value)" class="pointer" :class="'board-theme-' + theme">
          {{ value.name }}
        </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-breadcrumb
      separator="/"
      v-if="
        [
          'basic-bar',
          'bar',
          'line',
          'smoothed-line',
          'area-chart',
          'stacked-basic-bar',
          'stacked-bar',
          'pie',
          'ring-diagram',
          'funnel'
        ].includes(chartData.type)
      "
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item v-for="(data, index) in drawInfo" :key="index">
        <span @click="changeChart(data, index)" class="pointer" :class="'board-theme-' + theme">
          {{ data.name }}
        </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div
      class="total"
      v-if="chartData.extra && chartData.extra.showTotal"
      :class="'board-theme-' + theme"
    >
      <span>总计：{{ total }}</span>
    </div>
    <div v-if="useEChart" ref="myChart" class="image"></div>
    <ring-diagram
      v-if="ringShow"
      class="custom"
      :card="card"
      :yAxisList="chartData.showYAxisList"
      :indicatorStyle="indicatorStyle"
      :app-id="sheetAppId"
      :sheet-id="chartData.sheetId"
      :show-raw-data="showRawData"
      :quotas="quotas"
      ref="ring"
    ></ring-diagram>
    <pivot-vxe-table
      ref="pivotTable"
      v-if="crossShow"
      :raw-data="crossData.rawData"
      :x-axis-list="crossData.xAxisList"
      :y-axis-list="crossData.yAxisList"
      :summary-config="summaryConfig"
      :summary-position="summaryPosition"
      :rules="rules"
      :default-sort="defaultSort"
      :show-number="showNumber"
      :app-id="sheetAppId"
      :sheet-id="chartData.sheetId"
      :show-raw-data="showRawData"
      :quotas="quotas"
    ></pivot-vxe-table>
  </div>
</template>
<script>
import { getChartData, getExtraFields, getGeoJson, previewChartData } from "@/api/bi"
import { deepClone, getDealData } from "@/utils/common"
import RingDiagram from "./ring-diagram.vue"
import ChartMixin from "@/views/Backend/Admin/Statistics/chartEdit/ChartMixin"
import dj from "dayjs"
import { compareMethodMap } from "@/views/Backend/Admin/Statistics/static"
import {
  basicVertical,
  basicXVertical,
  chartMap,
  haiNanRec,
  mapPositionMap,
  positionMap,
  themeMapColor,
  timeMap
} from "@/views/Backend/Admin/Statistics/chartEdit/static"
import { getAvailableSheets, getSheet } from "@/api/sheet/sheet"
import { decorateSheet } from "@/utils/sheet"
import PivotVxeTable from "@/components/BI/PivotVxeTable"

export default {
  name: "chart-item",
  components: { RingDiagram, PivotVxeTable },
  data() {
    return {
      compareMethodMap,
      haiNanRec,
      themeMapColor,
      timeMap,
      positionMap,
      mapPositionMap,
      basicVertical,
      basicXVertical,
      chartMap,
      selectChart: "",
      chartData: {},
      card: {
        title: "",
        content: "",
        ids: ""
      },
      indicatorStyle: {
        titleColor: "#555555",
        titleFontsize: "14",
        numColor: "#555555",
        numFontsize: "48",
        before: "",
        after: ""
      },
      crossData: {
        rawData: [],
        yAxisList: [],
        xAxisList: []
      },
      ringShow: false,
      crossShow: false,
      myChart: null,
      axisData: [],
      xNames: [],
      yNames: [],
      yList: {},
      hashMap: new Map([[1, { name: "中国", value: 100000, parenVar: "" }]]),
      drawInfo: [],
      drillCount: 0,
      drillDownId: null,
      cId: null,
      sheetControls: [],
      sheetMap: {},
      quotas: [],
      legend: {},
      total: 0
    }
  },
  mixins: [ChartMixin],
  props: {
    chart: Object,
    hideHeader: Boolean,
    boardId: String,
    theme: {
      type: String,
      default: "walden"
    },
    dataId: String,
    appId: String
  },
  computed: {
    idAxisMap() {
      let result = {}
      this.chartData.xAxisList.concat(this.chartData.yAxisList).forEach(axis => {
        result[axis.id] = axis
      })
      return result
    },
    controlTypeMap() {
      let result = {}
      this.sheetControls.forEach(control => (result[control._cid] = control._type))
      return result
    },
    controlMap() {
      return this._.keyBy(this.sheetControls, "_cid")
    },
    chartLegend() {
      let result = ""
      if (this._.keys(this.chartData.extra).includes("showLegend")) {
        if (this.chartData.extra.showLegend) {
          result = this.chartData.extra?.legend
        }
      } else {
        result = "top"
      }
      return result
    },
    dataZoom() {
      return [
        {
          show:
            this.chartData.extra?.abbreviated === undefined
              ? false
              : this.chartData.extra?.abbreviated,
          type: "slider",
          start: 0,
          end: 100
        }
      ]
    },
    useEChart() {
      return !["cross-table", "indicator"].includes(this.selectChart)
    },
    summaryPosition() {
      let result = {}
      if (this.chartData.extra?.rowTotal) {
        result.rowTotalPosition = this.chartData.extra?.rowTotalPosition || "right"
      }
      if (this.chartData.extra?.columnTotal) {
        result.columnTotalPosition = this.chartData.extra?.columnTotalPosition || "bottom"
      }
      return result
    },
    summaryConfig() {
      let result = []
      if (this.chartData.extra?.rowTotal) {
        result = result.concat(this.chartData.extra?.rowTotalList || [])
      }
      if (this.chartData.extra?.columnTotal) {
        result = result.concat(this.chartData.extra?.columnTotalList || [])
      }
      if (this.chartData.extra?.kindColumnTotal) {
        result = result.concat(this.chartData.extra?.kindColumnTotalList || [])
      }
      return result
    },
    rules() {
      return this._.keys(this.chartData.extra).includes("rules") ? this.chartData.extra.rules : []
    },
    defaultSort() {
      return this._.keys(this.chartData.extra).includes("sortQuota") &&
        this.chartData.extra.sortQuota &&
        this.chartData.extra.sortMethod
        ? {
            direction: this.chartData.extra.sortMethod,
            key: this.chartData.extra.sortQuota,
            internal: this.chartData.extra.sortMethod.includes("group"),
            group: this.chartData.extra.sortGroup
          }
        : {}
    },
    showNumber() {
      return this._.keys(this.chartData.extra).includes("showNumber")
        ? this.chartData.extra.showNumber
        : false
    },
    showRawData() {
      return this.chartData.needIds || false
    },
    sheetAppId() {
      let sheet = this.sheetMap[this.chartData.sheetId]
      return sheet?.appId
    }
  },
  methods: {
    getDealData,
    getDataURL() {
      return this.myChart.getDataURL({
        type: "png",
        pixelRatio: 1.5,
        backgroundColor: "#fff"
      })
    },
    resize() {
      if (this.useEChart) {
        let json = require(`@/assets/boardTheme/${this.theme}.json`)
        this.$echarts.registerTheme(this.theme, json)
        this.$echarts.init(this.$refs.myChart, this.theme).resize()
      }
    },
    getSettReasonable() {
      let result = { result: true, message: "" }
      switch (this.chartData.type) {
        case "basic-bar":
        case "line":
        case "smoothed-line":
        case "area-chart":
        case "stacked-basic-bar":
        case "stacked-bar":
        case "bar":
          if (this.chartData.xAxisList.length === 2 && this.chartData.showYAxisList.length > 1) {
            result = {
              result: false,
              message:
                this.chartData.name +
                "【" +
                this.chartMap[this.chartData.type]?.name +
                "】设置两个维度时，只能显示一个指标"
            }
          }
          break
        case "ring-diagram":
        case "pie":
        case "indicator":
          if (this.chartData.showYAxisList.length > 1) {
            result = {
              result: false,
              message:
                this.chartData.name +
                "【" +
                this.chartMap[this.chartData.type]?.name +
                "】只能显示一个指标"
            }
          }
          break
        case "funnel":
          if (this.chartData.xAxisList.length === 1 && this.chartData.showYAxisList.length > 1) {
            result = {
              result: false,
              message:
                this.chartData.name +
                "【" +
                this.chartMap[this.chartData.type].name +
                "】设置一个维度时，只能显示一个指标"
            }
          }
          break
      }
      return result
    },
    init(chart) {
      this.chartData = deepClone(chart)
      this.chartData.showYAxisList = chart.yAxisList?.filter(yAxis => !yAxis.hidden)
      this.yNames = []
      this.selectChart = chart.type
      if (
        (!chart.xAxisList || chart.xAxisList.length === 0) &&
        !["indicator", "funnel"].includes(chart.type)
      ) {
        if (chart.type === "bar") this.$message.error((this.chartData.name || "") + "未设置Y轴数据")
        else this.$message.error((this.chartData.name || "") + "未设置X轴数据")
        return
      } else if (!this.chartData.showYAxisList || this.chartData.showYAxisList.length == 0) {
        if (chart.type == "bar") this.$message.error((this.chartData.name || "") + "未设置X轴数据")
        else this.$message.error((this.chartData.name || "") + "未设置Y轴数据")
        return
      }
      let uniqXAxisList = this._.uniqBy(chart.xAxisList, "name")
      let uniqYAxisList = this._.uniqBy(chart.yAxisList, "name")
      if (
        uniqXAxisList.length < chart.xAxisList.length ||
        uniqYAxisList.length < chart.yAxisList.length
      ) {
        this.$message.error("【" + (this.chartData.name || "") + "】维度或指标名称不能相同")
        return
      }
      let reasonable = this.getSettReasonable()
      if (!reasonable.result) {
        this.$message.error(reasonable.message)
        return
      }
      getSheet(this.chartData.sheetId).then(
        res =>
          (this.sheetControls = decorateSheet(res).controls.concat([
            { name: "创建人", _cid: "cid", _type: "staff" },
            { name: "负责人", _cid: "oid", _type: "staff" },
            { name: "最后修改人", _cid: "upid", _type: "staff" },
            { name: "创建时间", _cid: "cat", _type: "time" },
            { name: "最后修改时间", _cid: "uat", _type: "time" }
          ]))
      )
      getAvailableSheets({ appId: this.appId }).then(availableSheets => {
        this.sheetMap = Object.freeze(
          this._.keyBy(
            availableSheets.flatMap(app => app.sheets),
            "sheetId"
          )
        )
      })
      getExtraFields(this.chartData.sheetId).then(res => (this.quotas = res.fieldList))
      this.drawCharts()
    },
    drawCharts() {
      this.yNames = []
      if (this.selectChart === "cross-table") {
        this.drawCrossTable()
      } else if (this.selectChart === "indicator") {
        this.chartData.showYAxisList.map(yAxis => this.yNames.push(yAxis.name))
        this.drawIndicator()
      } else {
        if (this.myChart) this.myChart.dispose()
        let json = require(`@/assets/boardTheme/${this.theme}.json`)
        this.$echarts.registerTheme(this.theme, json)
        this.myChart = this.$echarts.init(this.$refs.myChart, this.theme)
        this.drillCount = this.chartData.xAxisList[0]?.drillDownList?.length
        this.cId = this.chartData.xAxisList[0]?.cid
        this.drawInfo[0] = {
          name: this.chartData.xAxisList[0]?.name,
          oldId: null,
          newId: null,
          oldCid: null,
          newCid: deepClone(this.cId)
        }
        this.drawEcharts()
      }
    },
    getFigureData(chart, drillDownId) {
      let filtersAll = []
      let resFilters = []
      filtersAll[0] = chart.filters
      chart.outerFilters = []
      let extraFilters = (chart.drillFilters || []).concat(chart.queryFilters || [])
      if (!this._.isEmpty(extraFilters)) {
        chart.outerFilters = [extraFilters]
        filtersAll[1] = [extraFilters]
      } else {
        filtersAll[1] = []
      }
      if (this._.keys(chart).includes("controlFilters")) {
        filtersAll[2] = chart.controlFilters
      }
      if (this._.keys(chart).includes("resultFilters")) {
        chart.resFilters = [chart.resultFilters]
        resFilters = [[chart.resultFilters]]
      }
      if (this.hideHeader) {
        if (!this.boardId) return
        return getChartData(
          chart.chartId,
          this.boardId,
          drillDownId,
          filtersAll,
          resFilters,
          this.dataId
        ).then(res => {
          this.axisData = res
          return res
        })
      } else
        return previewChartData(chart, drillDownId, this.boardId).then(res => {
          this.axisData = res
          this.chart.isShow = true
          return res
        })
    },
    async drawCrossTable() {
      let res = await this.getFigureData(this.chartData)
      res?.forEach(item => {
        this._.keys(item)
          .filter(key => this._.isArray(item[key]))
          .forEach(key => (item[key] = item[key].join(",")))
      })
      this.crossData = this.$options.data().crossData
      this.crossData.rawData = Object.freeze(res)
      this.crossData.xAxisList = this.chartData.xAxisList
      this.crossData.yAxisList = this.chartData.yAxisList
      this.crossShow = true
      this.$nextTick(() => this.$refs.pivotTable?.init())
    },
    async drawIndicator() {
      let res = await this.getFigureData(this.chartData)
      let yAxis = this.chartData.showYAxisList[0]
      if (res?.length) {
        this.card = {
          title: this.yNames[0],
          content: this.getDealData(this.getFormat(yAxis), res[0][yAxis.id], yAxis?.showThousands),
          ids: (res[0].ids || []).join(",")
        }
        this.indicatorStyle =
          this.chartData?.extra?.indicatorStyle || this.$options.data().indicatorStyle
      } else {
        this.card = {
          title: this.yNames[0],
          content: 0,
          ids: ""
        }
        this.indicatorStyle = this.$options.data().indicatorStyle
      }
      this.ringShow = true
    },
    changeChart(data, index) {
      this.drawInfo = this.drawInfo.slice(0, index + 1)
      this.drillDownId = data.oldId
      this.cId = data.oldCid
      this.getFilters()
      this.drillDownId = data.newId
      this.drillCount = this.chartData.xAxisList[0].drillDownList?.length - index
      this.cId = data.newCid
      this.drawEcharts()
    },
    async drawEcharts() {
      let drillDownId = this.drillDownId
      let res = await this.getFigureData(this.chartData, drillDownId)
      let data4 = []
      let data = []
      let data2 = {}
      let i = 1
      this.yNames = []
      let rowId = drillDownId ? drillDownId : this.chartData.xAxisList[0]?.id
      if (this.chartData.xAxisList.length === 2) {
        let cGroupId = this.chartData.xAxisList[1]?.id
        res.map(item => {
          if (Array.isArray(item[cGroupId])) item[cGroupId] = item[cGroupId][0]
          if (item[cGroupId] && !this.yNames.includes(item[cGroupId]))
            this.yNames.push(item[cGroupId])
          else if (!this.yNames.includes(item[cGroupId])) {
            let name = "未分组" + i++
            this.yNames.push(name)
            item[cGroupId] = name
          }
          if (!data.includes(item[rowId])) data.push(item[rowId])
        })
        for (let i = 0; i < this.yNames.length; i++) {
          let data5 = []
          for (let j = 0; j < data.length; j++) data5.push(null)
          data4[i] = data5
        }
        res.map(item => {
          let yId = this.chartData.showYAxisList[0].id
          data4[this.yNames.indexOf(item[cGroupId])][data.indexOf(item[rowId])] = item[yId]
        })
        this.yNames.map((name, index) => (data2[name] = data4[index]))
      } else {
        this.chartData.showYAxisList.map(yAxis => this.yNames.push(yAxis.name))
        this.getUnsortedData(res, rowId)?.map(item => {
          data.push(Array.isArray(item[rowId]) ? item[rowId][0] : item[rowId])
          this.chartData.showYAxisList.map(yAxis => {
            if (!data2[yAxis.name]) data2[yAxis.name] = []
            if (item[yAxis.id] === "Infinity") data2[yAxis.name].push(undefined)
            else data2[yAxis.name].push(item[yAxis.id])
          })
        })
      }
      this.setOption(res, rowId, data, data2)
    },
    getUnsortedData(res, rowId) {
      let xAxis = this.chartData.xAxisList[0]
      if (this.drillDownId) {
        xAxis = this.chartData.xAxisList[0].drillDownList.find(item => item.id === this.drillDownId)
      }
      if (
        !this._.keys(xAxis).includes("sortDirection") &&
        this.controlTypeMap[xAxis.cid] === "option"
      ) {
        let control = this.controlMap[xAxis.cid]
        let options = (control.options || []).map((option, index) => ({
          value: option.value,
          index: index
        }))
        let optionsMap = this._.keyBy(options, "value")
        return this._.sortBy(
          res.map(item =>
            Object.assign(item, {
              index: optionsMap[item[rowId]]?.index
            })
          ),
          "index"
        )
      } else {
        return res
      }
    },
    setOption(res, rowId, data, data2) {
      if (this.selectChart === "map") {
        this.rendChina()
        this.myChart.off("click").on("click", params => {
          switch (this.chartData.xAxisList[0].drillDownList?.length) {
            case 1:
              if (params.data !== undefined) this.drillDownCity(params)
              break
            case 2:
              if (params.data !== undefined) this.drillDownZone(params)
              break
          }
        })
        this.myChart.on("mouseover", params => {
          if (params.data === undefined) {
            this.myChart.dispatchAction({
              type: "downplay",
              seriesIndex: params.seriesIndex,
              dataIndex: params.dataIndex
            })
          }
        })
      } else {
        if (["pie", "ring-diagram"].includes(this.chartData.type)) {
          this.legend = Object.assign(
            { show: !!this.chartLegend, type: "scroll" },
            this.positionMap[this.chartLegend] || {}
          )
        } else if (
          [
            "basic-bar",
            "bar",
            "line",
            "smoothed-line",
            "area-chart",
            "stacked-basic-bar",
            "stacked-bar"
          ].includes(this.chartData.type)
        )
          this.legend = Object.assign(
            {},
            { data: this.yNames, show: !!this.chartLegend, type: "scroll" },
            this.positionMap[this.chartLegend] || {}
          )
        switch (this.selectChart) {
          case "pie":
            this.drawPie(res, rowId)
            break
          case "ring-diagram":
            this.drawRingDiagram(res, rowId)
            break
          case "basic-bar":
            this.drawBasicBar(data, data2)
            break
          case "bar":
            this.drawBar(data, data2)
            break
          case "line":
            this.drawLine(data, data2)
            break
          case "smoothed-line":
            this.drawSmoothedLine(data, data2)
            break
          case "area-chart":
            this.drawAreaChart(data, data2)
            break
          case "funnel":
            this.drawFunnel(res, data2, rowId)
            break
          case "stacked-basic-bar":
            this.drawStackedBasicBar(data, data2)
            break
          case "stacked-bar":
            this.drawStackedBar(data, data2)
            break
        }
        this.clickEvent()
      }
    },
    drawPie(res, rowId) {
      let yAxis = this.chartData.showYAxisList[0]
      let pieData = res?.map(item => {
        return {
          value: item[yAxis.id],
          name: Array.isArray(item[rowId]) ? item[rowId][0] : item[rowId]
        }
      })
      let topData = this.getTopData(pieData)
      this.total = this.getDealData(
        this.getFormat(yAxis),
        this._.sumBy(topData, "value"),
        yAxis?.showThousands
      )
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "item",
            formatter: params => {
              return this.getPieFormatData(params)
            }
          },
          legend: this.legend,
          series: [
            {
              name: yAxis.name,
              type: "pie",
              radius: "50%",
              data: topData,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              },
              label: {
                show: !this._.isEmpty(this.chartData.extra?.label),
                position: "outside",
                formatter: params => {
                  return this.getLabelFormData(params)
                }
              }
            }
          ]
        },
        true
      )
    },
    drawRingDiagram(res, rowId) {
      let yAxis = this.chartData.showYAxisList[0]
      let data = res?.map(item => {
        return {
          value: item[yAxis.id],
          name: Array.isArray(item[rowId]) ? item[rowId][0] : item[rowId]
        }
      })
      let topData = this.getTopData(data)
      this.total = this.getDealData(
        this.getFormat(yAxis),
        this._.sumBy(topData, "value"),
        yAxis?.showThousands
      )
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "item",
            formatter: params => {
              return this.getPieFormatData(params)
            }
          },
          legend: this.legend,
          series: [
            {
              name: this.yNames[0],
              type: "pie",
              radius: ["40%", "70%"],
              avoidLabelOverlap: false,
              label: {
                show: !this._.isEmpty(this.chartData.extra?.label),
                position: "outside",
                formatter: params => {
                  return this.getLabelFormData(params)
                }
              },
              data: topData
            }
          ]
        },
        true
      )
    },
    drawBasicBar(data, data2) {
      let series = this.yNames.map(name => {
        return Object.assign(
          {},
          {
            name: name,
            type: "bar",
            barGap: 0,
            label: {
              show: this.chartData.extra?.dataLabel,
              position: "top",
              formatter: params => {
                return this.getLabelFormData(params)
              }
            },
            emphasis: {
              focus: "series"
            },
            yAxisIndex: this.getYAxisIndex(name),
            data: this.getTopData(data2[name])
          },
          this.getMarkLine(name)
        )
      })
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            },
            formatter: params => {
              return this.getFormatData(params)
            }
          },
          legend: this.legend,
          grid: {
            left: "15%"
          },
          xAxis: {
            type: "category",
            data: this.getTopData(data),
            name: this.chartData.extra?.xAxisTitle || "",
            nameLocation: "center",
            nameGap: 36,
            axisLabel: {
              rotate: this.chartData.extra?.incline ? -45 : 0
            }
          },
          yAxis: this.getYAxis(),
          series: series,
          dataZoom: this.dataZoom
        },
        true
      )
    },
    drawBar(data, data2) {
      let data3 = this.yNames.map(name => {
        return Object.assign(
          {},
          {
            name: name,
            type: "bar",
            barGap: 0,
            label: {
              show: this.chartData.extra?.dataLabel,
              position: this.chartData.extra?.labelPosition || "inside",
              formatter: params => {
                return this.getLabelFormData(params)
              }
            },
            emphasis: {
              focus: "series"
            },
            data: this.getTopData(data2[name])
          },
          this.getMarkLine(name)
        )
      })
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            },
            formatter: params => {
              return this.getFormatData(params)
            }
          },
          legend: this.legend,
          grid: {
            left: "3%",
            right: "4%",
            bottom: "18%",
            containLabel: true
          },
          xAxis: {
            type: "value",
            name: this.chartData.extra?.showYAxisTitle ? this.chartData.extra?.yAxisTitle : "",
            nameLocation: "center",
            nameGap: 36
          },
          yAxis: Object.assign(
            {},
            {
              type: "category",
              data: this.getBarData(data),
              axisLabel: {
                rotate: this.chartData.extra?.incline ? -45 : 0
              },
              name: this.getAxisName(this.chartData.extra?.xAxisTitle)
            },
            this.basicXVertical
          ),
          series: data3,
          dataZoom: this.dataZoom
        },
        true
      )
    },
    drawLine(data, data2) {
      let data3 = this.yNames.map(name => {
        return Object.assign(
          {},
          {
            name: name,
            type: "line",
            barGap: 0,
            label: {
              show: this.chartData.extra?.dataLabel,
              position: "top",
              formatter: params => {
                return this.getLabelFormData(params)
              }
            },
            emphasis: {
              focus: "series"
            },
            yAxisIndex: this.getYAxisIndex(name),
            data: this.getTopData(data2[name])
          },
          this.getMarkLine(name)
        )
      })
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            },
            formatter: params => {
              return this.getFormatData(params)
            }
          },
          legend: this.legend,
          xAxis: {
            type: "category",
            data: this.getTopData(data),
            name: this.chartData.extra?.xAxisTitle || "",
            nameLocation: "center",
            nameGap: 36,
            axisLabel: {
              rotate: this.chartData.extra?.incline ? -45 : 0
            }
          },
          grid: {
            left: "15%"
          },
          yAxis: this.getYAxis(),
          series: data3,
          dataZoom: this.dataZoom
        },
        true
      )
    },
    drawSmoothedLine(data, data2) {
      let data3 = this.yNames.map(name => {
        return Object.assign(
          {},
          {
            name: name,
            type: "line",
            smooth: true,
            barGap: 0,
            label: {
              show: this.chartData.extra?.dataLabel,
              position: "top",
              formatter: params => {
                return this.getLabelFormData(params)
              }
            },
            emphasis: {
              focus: "series"
            },
            yAxisIndex: this.getYAxisIndex(name),
            data: this.getTopData(data2[name])
          },
          this.getMarkLine(name)
        )
      })
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            },
            formatter: params => {
              return this.getFormatData(params)
            }
          },
          legend: this.legend,
          grid: {
            left: "15%"
          },
          xAxis: {
            type: "category",
            data: this.getTopData(data),
            name: this.chartData.extra?.xAxisTitle || "",
            nameLocation: "center",
            nameGap: 36,
            axisLabel: {
              rotate: this.chartData.extra?.incline ? -45 : 0
            }
          },
          yAxis: this.getYAxis(),
          series: data3,
          dataZoom: this.dataZoom
        },
        true
      )
    },
    drawAreaChart(data, data2) {
      let data3 = this.yNames.map(name => {
        return Object.assign(
          {},
          {
            name: name,
            type: "line",
            stack: "总量",
            areaStyle: {},
            emphasis: {
              focus: "series"
            },
            label: {
              show: this.chartData.extra?.dataLabel,
              position: "top",
              formatter: params => {
                return this.getLabelFormData(params)
              }
            },
            yAxisIndex: this.getYAxisIndex(name),
            data: this.getTopData(data2[name])
          },
          this.getMarkLine(name)
        )
      })
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            },
            formatter: params => {
              return this.getFormatData(params)
            }
          },
          legend: this.legend,
          grid: {
            left: "15%"
          },
          xAxis: {
            type: "category",
            data: this.getTopData(data),
            name: this.chartData.extra?.xAxisTitle || "",
            nameLocation: "center",
            nameGap: 36,
            axisLabel: {
              rotate: this.chartData.extra?.incline ? -45 : 0
            }
          },
          yAxis: this.getYAxis(),
          series: data3,
          dataZoom: this.dataZoom
        },
        true
      )
    },
    drawFunnel(res, data2, rowId) {
      let funnelData = this.getFunnelData(data2, res, rowId)
      let legendData = funnelData?.map(f => f.name)
      let dataList = funnelData?.map(f => f.value)
      let upperData = this.getFunnelUpperData(dataList)
      let firstData = dataList?.map((d, index) => {
        if (index === 0) return "100%"
        else return ((d / dataList[0]) * 100).toFixed(2) + "%"
      })
      let data3 = [
        {
          type: "funnel",
          sort: "none",
          label: {
            show: !this._.isEmpty(this.chartData.extra?.label),
            formatter: params => {
              return this.getFunnelLabel(params, upperData, firstData)
            },
            position: "inside"
          },
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 1
          },
          emphasis: {
            label: {
              fontSize: 20
            }
          },
          minSize: "30%",
          data: funnelData
        }
      ]
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "item",
            formatter: params => {
              return this.getFunnelFormatData(params, res, firstData, upperData)
            }
          },
          legend: Object.assign(
            {},
            { data: legendData, show: !!this.chartLegend, type: "scroll" },
            this.positionMap[this.chartLegend] || {}
          ),
          series: data3
        },
        true
      )
    },
    drawStackedBasicBar(data, data2) {
      let data3 = this.yNames.map(name => {
        return Object.assign(
          {},
          {
            name: name,
            type: "bar",
            stack: "total",
            barGap: 0,
            label: {
              show: this.chartData.extra?.dataLabel,
              position: "top",
              formatter: params => {
                return this.getLabelFormData(params)
              }
            },
            emphasis: {
              focus: "series"
            },
            yAxisIndex: this.getYAxisIndex(),
            data: this.getTopData(data2[name])
          },
          this.getMarkLine(name)
        )
      })
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            },
            formatter: params => {
              return this.getFormatData(params)
            }
          },
          legend: this.legend,
          grid: {
            left: "15%"
          },
          xAxis: {
            type: "category",
            data: this.getTopData(data),
            name: this.chartData.extra?.xAxisTitle || "",
            nameLocation: "center",
            nameGap: 36,
            axisLabel: {
              rotate: this.chartData.extra?.incline ? -45 : 0
            }
          },
          yAxis: this.getYAxis(),
          series: data3,
          dataZoom: this.dataZoom
        },
        true
      )
    },
    drawStackedBar(data, data2) {
      let data3 = this.yNames.map(name => {
        return Object.assign(
          {},
          {
            name: name,
            type: "bar",
            stack: "total",
            barGap: 0,
            label: {
              show: this.chartData.extra?.dataLabel,
              position: "inside",
              formatter: params => {
                return this.getLabelFormData(params)
              }
            },
            emphasis: {
              focus: "series"
            },
            data: this.getTopData(data2[name])
          },
          this.getMarkLine(name)
        )
      })
      this.myChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            },
            formatter: params => {
              return this.getFormatData(params)
            }
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "18%",
            containLabel: true
          },
          legend: this.legend,
          xAxis: {
            type: "value",
            name: this.chartData.extra?.showYAxisTitle ? this.chartData.extra?.yAxisTitle : "",
            nameLocation: "center",
            nameGap: 36
          },
          yAxis: Object.assign(
            {},
            {
              type: "category",
              data: this.getBarData(data),
              axisLabel: {
                rotate: this.chartData.extra?.incline ? -45 : 0
              },
              name: this.getAxisName(this.chartData.extra?.xAxisTitle)
            },
            this.basicXVertical
          ),
          series: data3,
          dataZoom: this.dataZoom
        },
        true
      )
    },
    clickEvent() {
      if (["pie", "ring-diagram", "funnel"].includes(this.selectChart)) {
        this.myChart.off("click").on("click", params => {
          this.drillEvent(params.name)
        })
      } else {
        this.myChart.getZr().off("click")
        this.myChart.getZr().on("click", params => {
          let pointInPixel = [params.offsetX, params.offsetY]
          let name = null
          if (this.myChart.containPixel("grid", pointInPixel)) {
            let series = this.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)
            let index = ["bar", "stacked-bar"].includes(this.selectChart) ? series[1] : series[0]
            name = ["bar", "stacked-bar"].includes(this.selectChart)
              ? this.myChart.getOption().yAxis[0].data[Number(index)].drillValue
              : this.myChart.getOption().xAxis[0].data[Number(index)]
            this.drillEvent(name)
          }
        })
      }
    },
    drillEvent(name) {
      if (this.drillCount > 0) {
        let info = { name: name, oldId: this.drillDownId, oldCid: this.cId }
        let index = this.chartData.xAxisList[0].drillDownList?.length - this.drillCount
        this.drillDownId = this.chartData.xAxisList[0].drillDownList[index].id
        this.cId = this.chartData.xAxisList[0].drillDownList[index].cid
        info.newId = this.drillDownId
        info.newCid = this.cId
        this.drawInfo.push(info)
        this.getFilters()
        this.drillCount = this.drillCount - 1
        this.drawEcharts()
      } else {
        if (this.chartData.xAxisList[0]?.drillDownList?.length > 0) {
          this.$message.warning("已经钻取到最后一层了！")
        }
      }
    },
    getFilters() {
      let filters = []
      this.drawInfo.forEach((info, index) => {
        if (index > 0) {
          filters.push(...this.getFilter(info))
        }
      })
      this.chartData.drillFilters = filters
    },
    getFilter(info) {
      let filters = []
      let type = this.controlTypeMap[info.oldCid]
      switch (type) {
        case "time":
          filters = [this.getTimeFilter("begin", info), this.getTimeFilter("end", info)]
          break
        case "option":
          filters = [this.getOptionFilter(info.name, info.oldCid)]
          break
        case "text":
          filters = [this.getTextFilter(info.name, info.oldCid)]
          break
      }
      return filters
    },
    getTimeFilter(type, info) {
      let filter = {}
      filter.compareMethod = this.compareMethodMap[type]
      filter.key = info.oldCid
      filter.type = "time"
      filter.value = null
      let item = {}
      switch (type) {
        case "begin":
          item = { value: this.getStart(info) }
          break
        case "end":
          item = { value: this.getEnd(info) }
          break
      }
      item.var = false
      filter.varItems = [item]
      return filter
    },
    getTimeType(info) {
      let axis = {}
      if (info.oldId) {
        axis = this.chartData.xAxisList[0].drillDownList.find(drill => drill.id === info.oldId)
      } else {
        axis = this.chartData.xAxisList[0]
      }
      let timeType = ""
      if (axis?.projectType) {
        timeType = axis?.projectType
      } else {
        timeType = axis?.control.timeType
      }
      return timeType
    },
    getUnit(info) {
      let result = ""
      let timeType = this.getTimeType(info)
      switch (timeType) {
        case "年":
          result = "year"
          break
        case "半年度":
        case "季度":
        case "月":
          result = "month"
          break
        case "周":
        case "日":
          result = "day"
          break
      }
      return result
    },
    getCount(info) {
      let result = 1
      let timeType = this.getTimeType(info)
      switch (timeType) {
        case "周":
          result = 7
          break
        case "半年度":
          result = 6
          break
        case "季度":
          result = 3
          break
        default:
          result = 1
          break
      }
      return result
    },
    getOptionFilter(option, cid) {
      let filter = {}
      filter.compareMethod = "包含"
      filter.key = cid
      filter.type = "option"
      filter.value = null
      filter.varItems = [{ value: option, var: false }]
      return filter
    },
    getTextFilter(text, cid) {
      let filter = {}
      filter.compareMethod = "是"
      filter.key = cid
      filter.type = "text"
      filter.value = null
      filter.varItems = [{ value: text, var: false }]
      return filter
    },
    dealTime(time) {
      let period = time.slice(4)
      if (this._.keys(this.timeMap).includes(period)) {
        return time.slice(0, 4) + " " + this.timeMap[period]
      } else {
        return time
      }
    },
    getStart(info) {
      let time = this.dealTime(info.name)
      let unit = this.getUnit(info)
      if (["year", "month", "day"].includes(unit)) {
        return dj(time)
          .startOf(unit)
          .format("YYYY-MM-DD HH:mm:ss")
      } else if (unit === "minute") {
        return time + ":00"
      } else {
        return time
      }
    },
    getEnd(info) {
      let unit = this.getUnit(info)
      let count = this.getCount(info)
      let time = this.dealTime(info.name)
      if (["year", "month", "day"].includes(unit)) {
        return dj(time)
          .add(count - 1, unit)
          .endOf(unit)
          .format("YYYY-MM-DD HH:mm:ss")
      } else if (unit === "minute") {
        return time + ":59"
      } else {
        return time
      }
    },
    drillDownCity(params) {
      const { name, code, parentVar } = params.data
      switch (params.data.zoom) {
        case 1:
          this.rendProvince(name, code, parentVar)
          this.setHashMap(params.data.zoom + 1, name, code, parentVar)
          break
        case 2:
          this.$message.warning("已经钻取到最后一层了！")
          break
      }
    },
    drillDownZone(params) {
      const { name, code, parentVar } = params.data
      switch (params.data.zoom) {
        case 1:
          this.rendProvince(name, code, parentVar)
          this.setHashMap(params.data.zoom + 1, name, code, parentVar)
          break
        case 2:
          this.rendCity(name, code, parentVar)
          this.setHashMap(params.data.zoom + 1, name, code, parentVar)
          break
        case 3:
          this.$message.warning("已经钻取到最后一层了！")
          break
      }
    },
    async rendChina() {
      let res = await getGeoJson("100000_full")
      let china = {}
      let features = res.data.features.slice(0, res.data.features.length - 1)
      features.push(this.haiNanRec)
      china.features = features
      china.type = "FeatureCollection"
      let xId = this.chartData.xAxisList[0].id
      let yId = this.chartData.showYAxisList[0].id
      let mapName = []
      this.chartData.drillFilters = []
      await this.getFigureData(this.chartData)
      for (let axis of this.axisData) {
        for (let province of china.features) {
          if (province.properties.name.includes(axis[xId])) {
            mapName.push({
              name: province.properties.name,
              value: axis[yId],
              code: province.properties.adcode,
              parentVar: this.getMapValue("province", "", province.properties.name),
              zoom: 1
            })
            break
          }
        }
      }
      this.$echarts.registerMap("中国", china, {
        海南省: {
          // 海南移到中国大陆右下角
          left: 128,
          top: 20.5,
          width: 3.6
        }
      })
      this.renderMap("中国", mapName)
    },
    getMapFilter(value) {
      let filter = {}
      filter.compareMethod = "在...中"
      filter.key = this.chartData.xAxisList[0].cid
      filter.type = "area"
      filter.value = null
      filter.varItems = [{ var: false, value: value }]
      return [filter]
    },
    getMapValue(from, parentVar, name) {
      let result = ""
      if (name !== undefined) {
        if (from === "province") {
          result = ["内蒙古自治区", "黑龙江省"].includes(name) ? name.slice(0, 3) : name.slice(0, 2)
        } else {
          result = parentVar + "-" + name
        }
      }
      return result
    },
    async rendProvince(name, code, parentVar) {
      let res = await getGeoJson(code + "_full")
      let provinceData = res.data
      this.$echarts.registerMap(name, provinceData)
      const cityName = []
      this.chartData.drillFilters = this.getMapFilter(parentVar)
      let drillDownId = this.chartData.xAxisList[0].drillDownList[0].id
      this.drillDownId = drillDownId
      await this.getFigureData(this.chartData, drillDownId)
      let xId = drillDownId
      let yId = this.chartData.showYAxisList[0].id
      for (let axis of this.axisData) {
        for (let city of provinceData.features) {
          if (city.properties.name.includes(axis[xId].split("-")[1])) {
            cityName.push({
              name: city.properties.name,
              value: axis[yId],
              code: city.properties.adcode,
              parentVar: this.getMapValue("city", parentVar, city.properties.name),
              parent: code,
              zoom: 2
            })
            break
          }
        }
      }
      this.renderMap(name, cityName)
    },
    async rendCity(name, code, parentVar) {
      let res = await getGeoJson(code + "_full")
      let cityData = res.data
      this.$echarts.registerMap(name, cityData)
      const countyName = []
      this.chartData.drillFilters = this.getMapFilter(parentVar)
      let drillDownId = this.chartData.xAxisList[0].drillDownList[1].id
      this.drillDownId = drillDownId
      await this.getFigureData(this.chartData, drillDownId)
      let xId = drillDownId
      let yId = this.chartData.showYAxisList[0].id
      for (let axis of this.axisData) {
        for (let county of cityData.features) {
          if (county.properties.name.includes(axis[xId].split("-")[2])) {
            countyName.push({
              name: county.properties.name,
              value: axis[yId],
              data: county,
              parent: code,
              parentVar: this.getMapValue("county", parentVar, county.properties.name),
              zoom: 3
            })
            break
          }
        }
      }
      this.renderMap(name, countyName)
    },
    renderMap(map, cityNameList) {
      this.total = this._.sumBy(cityNameList, "value")
      let data3 = [
        {
          nameMap: map,
          name: map,
          type: "map",
          map: map,
          emphasis: {
            label: {
              show: true
            }
          },
          label: {
            show: !this._.isEmpty(this.chartData.extra?.label),
            position: "inside",
            formatter: params => {
              return this.getLabelFormData(params)
            },
            color: "#303133"
          },
          selectedMode: false,
          data: cityNameList
        }
      ]
      let min = 0
      let max = 10
      let values = cityNameList.map(item => item.value)
      if (values.length > 0) {
        min = this._.min(values) - 1
        max = this._.max(values) + 1
      }
      this.myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: params => {
            return this.getMapFormatData(params)
          }
        },
        visualMap: Object.assign(
          {},
          {
            min: min,
            max: max,
            realtime: false,
            calculable: true,
            itemWidth: 12,
            itemHeight: 80,
            text: ["最大值", "最小值"],
            show: !!this.chartLegend,
            inRange: {
              color: this.themeMapColor[this.theme]
            }
          },
          this.mapPositionMap[this.chartLegend] || {}
        ),
        series: data3
      })
    },
    setHashMap(zoom, name, value, parentVar) {
      this.hashMap.set(1, {
        name: "中国",
        value: "100000",
        parentVar: ""
      })
      this.hashMap.set(zoom, {
        name: name,
        value: value,
        parentVar: parentVar
      })
      this.hashMap.delete(zoom + 1)
      this.hashMap = new Map(this.hashMap)
    },
    clearHashMap() {
      this.hashMap.clear()
      this.hashMap.set(1, {
        name: "中国",
        value: "100000",
        parentVar: ""
      })
      this.hashMap = new Map(this.hashMap)
    },
    initMap(key, { name, value, parentVar }) {
      switch (key) {
        case 1:
          this.rendChina()
          this.clearHashMap()
          break
        case 2:
          this.rendProvince(name, value, parentVar)
          this.setHashMap(key, name, value, parentVar)
          break
        case 3:
          this.rendCity(name, value, parentVar)
          this.setHashMap(key, name, value, parentVar)
          break
        default:
          break
      }
    },
    getFunnelData(data, res, rowId) {
      if (this.chartData.xAxisList.length === 1) {
        let yId = this.chartData.showYAxisList[0].id
        let xAxis = this.chartData.xAxisList[0]
        if (this.controlTypeMap[xAxis.cid] === "option") {
          let control = this.controlMap[xAxis.cid]
          let options = (control.options || []).map((option, index) => ({
            value: option.value,
            index: index
          }))
          let optionsMap = this._.keyBy(options, "value")
          return this._.sortBy(
            res
              ?.filter(item => this._.keys(optionsMap).includes(item[rowId]))
              .map(item =>
                Object.assign({
                  name: item[rowId],
                  value: item[yId],
                  index: optionsMap[item[rowId]]?.index
                })
              ),
            "index"
          )
        } else {
          return res?.map(item => ({ name: item[rowId], value: item[yId] }))
        }
      } else {
        return this.yNames.map(name => ({
          name: name,
          value: data[name] ? data[name][0] : 0
        }))
      }
    },
    getFunnelLabel(params, upperData, firstData) {
      let yAxis =
        this.chartData.xAxisList.length === 1
          ? this.chartData.showYAxisList[0]
          : this.chartData.showYAxisList[params.dataIndex]
      let result = ""
      if (this.chartData.extra?.label?.includes("tag")) {
        result = result + params.data.name
      }
      if (this.chartData.extra?.label?.includes("quota")) {
        result =
          result +
          " " +
          this.getDealData(this.getFormat(yAxis), params.data.value, yAxis?.showThousands)
      }
      if (this.chartData.extra?.label?.includes("percent")) {
        if (this.chartData.extra?.percentType === "last")
          result = result + " (" + upperData[params.dataIndex] + ")"
        if (this.chartData.extra?.percentType === "first")
          result = result + " (" + firstData[params.dataIndex] + ")"
      }
      return result
    },
    getMapFormatData(params) {
      if (params.data !== undefined) {
        let data = `${params.marker} ${params.data.name}` + "<br/>"
        this.chartData.showYAxisList.forEach(
          yAxis =>
            (data =
              data +
              yAxis.name +
              ": " +
              this.getDealData(this.getFormat(yAxis), params.data.value, yAxis?.showThousands) +
              "<br/>")
        )
        return data
      } else {
        return ""
      }
    },
    getPieFormatData(params) {
      let yAxis = this.chartData.showYAxisList[0]
      return (
        this.yNames[0] +
        "<br>" +
        `${params.marker} ${params.data?.name}: ` +
        this.getDealData(this.getFormat(yAxis), params.data.value, yAxis?.showThousands) +
        " (" +
        params.percent +
        "%)"
      )
    },
    getLabelFormData(params) {
      let yAxis =
        this.chartData.xAxisList.length === 2
          ? this.chartData.showYAxisList[0]
          : this.chartData.showYAxisList[params.seriesIndex]
      let result = ""
      if ("map" === this.chartData.type) {
        if (params.data !== undefined) {
          if (this.chartData.extra?.label.includes("dimension")) result = result + params.data.name
          if (this.chartData.extra?.label.includes("quota"))
            result =
              result +
              " " +
              this.getDealData(this.getFormat(yAxis), params.data.value, yAxis?.showThousands)
        }
        return result
      } else if (["ring-diagram", "pie"].includes(this.chartData.type)) {
        if (this.chartData.extra?.label.includes("tag")) result = result + params.data.name
        if (this.chartData.extra?.label.includes("number"))
          result =
            result +
            " " +
            this.getDealData(this.getFormat(yAxis), params.data.value, yAxis?.showThousands)
        if (this.chartData.extra?.label.includes("percent"))
          result = result + " (" + params.percent + "%)"
        return result
      } else {
        return params.value === 0
          ? ""
          : this.getDealData(this.getFormat(yAxis), params.value, yAxis?.showThousands)
      }
    },
    getFormatData(params) {
      let str = params[0].axisValue + "<br>"
      params
        .filter(item => item.data !== null)
        .forEach((item, index) => {
          let yAxis = {}
          if (this.chartData.xAxisList.length === 2) {
            yAxis = this.chartData.showYAxisList[0]
          } else {
            yAxis = this.chartData.showYAxisList[item.seriesIndex]
          }
          let data = item.data
          str +=
            `${item.marker}${item.seriesName}: ` +
            this.getDealData(this.getFormat(yAxis), data, yAxis?.showThousands)
          str += index === params.length - 1 ? "" : "<br/>"
        })
      return str
    },
    getFunnelUpperData(dataList) {
      return dataList?.map((d, index) => {
        if (index === 0) return "100%"
        else return ((d / dataList[index - 1]) * 100).toFixed(2) + "%"
      })
    },
    getFunnelFormatData(params, res, firstData, upperData) {
      let yAxis =
        this.chartData.xAxisList.length === 1
          ? this.chartData.showYAxisList[0]
          : this.chartData.showYAxisList[params.dataIndex]
      return (
        `${params.marker} ${params.data.name}` +
        "<br/>" +
        "值: " +
        this.getDealData(this.getFormat(yAxis), params.data.value, yAxis?.showThousands) +
        "<br/>" +
        "占上一层百分比: " +
        upperData[params.dataIndex] +
        "<br/>" +
        "占第一层百分比: " +
        firstData[params.dataIndex]
      )
    },
    getBarData(data) {
      let barData = this.getTopData(data)
      if (this.chartData.extra?.showSort) {
        barData = barData.map((data, index) => {
          return {
            value: barData.length - index + ". " + data,
            drillValue: data,
            textStyle: {
              fontWeight: barData.length - index <= 3 ? "700" : "",
              fontSize: barData.length - index <= 3 ? 13 : 12
            }
          }
        })
      }
      return barData
    },
    getTopData(data) {
      let result = []
      let barData = []
      if (["bar", "stacked-bar"].includes(this.chartData.type))
        barData = this._.reverse(deepClone(data))
      if (this.chartData.extra?.filterNumber) {
        if (data?.length > this.chartData.extra.filterNumber) {
          result = ["bar", "stacked-bar"].includes(this.chartData.type)
            ? this._.reverse(data.slice(0, this.chartData.extra.filterNumber))
            : data.slice(0, this.chartData.extra.filterNumber)
        } else {
          result = ["bar", "stacked-bar"].includes(this.chartData.type) ? barData : data
        }
      } else {
        result = ["bar", "stacked-bar"].includes(this.chartData.type) ? barData : data
      }
      return result
    },
    getYAxisIndex(name) {
      let curYAxis = this.chartData.showYAxisList.find(yAxis => yAxis.name === name)
      if (this.chartData.extra?.doubleY) {
        if (this.chartData.extra?.right.includes(curYAxis.id)) {
          return 1
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    getMarkLine(name) {
      let curYAxis = this.chartData.showYAxisList.find(yAxis => yAxis.name === name)
      let curLines =
        this.chartData.extra?.lines?.filter(line =>
          line.kind === "fixed" ? true : line.fieldId === curYAxis?.id
        ) || []
      let data = curLines?.map(line => {
        return line.kind === "fixed"
          ? ["bar", "stacked-bar"].includes(this.chartData.type)
            ? { xAxis: line.number, name: line.name, lineStyle: { color: line.color } }
            : { yAxis: line.number, name: line.name, lineStyle: { color: line.color } }
          : { type: line.calc, name: line.name, lineStyle: { color: line.color } }
      })
      return this._.isEmpty(data)
        ? {}
        : {
            markLine: {
              data: data,
              symbol: "none",
              label: {
                show: true,
                formatter: "{b}: {c}"
              }
            }
          }
    },
    getYAxis() {
      if (this.chartData.extra?.doubleY) {
        return [
          Object.assign({}, this.basicVertical, {
            name: this.getAxisName(
              this.chartData.extra?.showYAxisTitle ? this.chartData.extra?.yAxisTitle : ""
            )
          }),
          Object.assign({}, this.basicVertical, {
            name: this.getAxisName(
              this.chartData.extra?.showYAxisTitle ? this.chartData.extra?.rightYAxisTitle : ""
            )
          })
        ]
      } else {
        return [
          Object.assign({}, this.basicVertical, {
            name: this.getAxisName(
              this.chartData.extra?.showYAxisTitle ? this.chartData.extra?.yAxisTitle : ""
            )
          })
        ]
      }
    },
    getAxisName(title) {
      let str = title?.split("") || []
      return str.join("\n")
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-item {
  position: relative;
  .el-breadcrumb {
    position: absolute;
    bottom: 15px;
    left: 10px;
    z-index: 10;
    font-size: 12px;
  }
  .total {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 10;
    font-size: 14px;
    font-weight: 500;
  }
  .image {
    text-align: left;
    position: relative;
    overflow: hidden;
    flex: 1;
    height: 100%;
    width: 100%;
  }
  .custom {
    position: absolute;
    top: 1px;
  }
}
</style>
